module.exports = "/fonts/vendor/boxicons/boxicons.woff2?b5e3cc0c6aa650c9e3ba523df059dc17";